"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPixelProperties = void 0;
const traverse_1 = __importDefault(require("traverse"));
const isBuilderPixel = (item) => {
    var _a, _b;
    return (_b = (_a = item) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.startsWith('builder-pixel');
};
function setPixelProperties(content, properties) {
    return traverse_1.default(content).forEach(function (item) {
        if (isBuilderPixel(item)) {
            this.update(Object.assign(Object.assign({}, item), { properties: Object.assign(Object.assign(Object.assign({}, item.properties), properties), { src: item.properties.src }) }));
        }
    });
}
exports.setPixelProperties = setPixelProperties;
